const { useEffect } = require("react");

const PrivacyPolicyRedirect = () => {
  const privacyPolicyLink = "https://noki.ai/privacy-policy/";

  useEffect(() => {
    try {
      window.location.href = privacyPolicyLink;
    } catch (error) {
      console.error("Redirection failed:", error);
    }
  }, []);

  return null;
};

export default PrivacyPolicyRedirect;
